# Copy to clipboard behavior
$(document).on "click", "[data-behavior~='copy-to-clipboard'] button", (e) ->
  input = $(e.target).closest("[data-behavior~=copy-to-clipboard]").find("input")
  return if input.prop("disabled")
  success = false

  try
    if window.clipboardData
      success = window.clipboardData.setData("Text", input.val())
    else
      input.select()
      success = document.execCommand("copy")

  if success
    message = input.data("message") || "The text has been copied to your clipboard!"
    contently.flash.success(message)
  else
    message = "Sorry, we were unable to copy the text to your clipboard. Please copy manually."
    contently.flash.alert(message)

$(document).on "focus, click", "[data-behavior~='copy-to-clipboard'] input", (e) ->
  e.target.select()



// WEBPACK FOOTER //
// ./app/javascript/lib/toolkit/behaviors/widget.js.coffee